module.exports = __webpack_public_path__ + "img/FilterIcon.1609ebbc.svg";